import { createEventBus } from './events';

const STORAGE_KEY = 'galletas4all_consent';

export interface ConsentRecord {
  accepted: boolean;
  categories: string[];
  timestamp: string;
}

const bus = createEventBus<ConsentRecord>();

let cache: ConsentRecord | null | undefined = undefined; // undefined = not loaded; null = loaded-but-empty

function readFromStorage(): ConsentRecord | null {
  let saved: string | null = null;
  try {
    saved = localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
  if (!saved) return null;
  try {
    return JSON.parse(saved) as ConsentRecord;
  } catch {
    return null;
  }
}

export const ConsentStore = {
  save(record: ConsentRecord): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch {
      // ignore quota / blocked storage
    }
    cache = record;
    bus.emit(record);
  },

  load(): ConsentRecord | null {
    if (cache === undefined) {
      cache = readFromStorage();
    }
    return cache;
  },

  hasConsentForCategory(category: string): boolean {
    const record = ConsentStore.load();
    return record !== null && Array.isArray(record.categories) && record.categories.includes(category);
  },

  onChange(listener: (record: ConsentRecord) => void): () => void {
    return bus.on(listener);
  },

  /** Test-only: forces next load() to re-read storage. Not exported via esm-entry. */
  __resetCache(): void {
    cache = undefined;
  },
};
